// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2fbDNoxq3ZdaqiGAfXulwW {\n  margin: 1em 0;\n}\n\n._2droeBkqBndCJasqvL-JXC {\n  opacity: 0.6;\n}\n", ""]);
// Exports
exports.locals = {
	"add": "_2fbDNoxq3ZdaqiGAfXulwW",
	"passive": "_2droeBkqBndCJasqvL-JXC"
};
module.exports = exports;
